<div class="pkt-menu-btn-wrapper">
  <!-- flat -->
  <button *ngIf="variant === 'flat'" mat-flat-button [color]="color" [disabled]="disabled" [matMenuTriggerFor]="menu"
    class="pkt-btn" [matTooltip]="tooltip" [matTooltipDisabled]="!tooltip">
    <span *ngIf="icon" class="material-symbols-outlined">{{ icon }}</span>
    <span *ngIf="label">{{ label }}</span>
    <span class="material-symbols-outlined pkt-chevron">keyboard_arrow_down</span>
  </button>

  <!-- stroked -->
  <button *ngIf="variant === 'stroked'" mat-stroked-button [color]="color" [disabled]="disabled"
    [matMenuTriggerFor]="menu" class="pkt-btn" [matTooltip]="tooltip" [matTooltipDisabled]="!tooltip">
    <span *ngIf="icon" class="material-symbols-outlined">{{ icon }}</span>
    <span *ngIf="label">{{ label }}</span>
    <span class="material-symbols-outlined pkt-chevron">keyboard_arrow_down</span>
  </button>

  <!-- icon only -->
  <button *ngIf="variant === 'icon'" mat-icon-button [disabled]="disabled" [matMenuTriggerFor]="menu"
    [class.pkt-icon-btn--bordered]="bordered" [ngClass]="themeClass"
    [matTooltip]="tooltip" [matTooltipDisabled]="!tooltip">
    <span class="material-symbols-outlined">{{ icon || 'more_vert' }}</span>
  </button>

  <!-- text -->
  <button *ngIf="variant === 'text'" mat-button [disabled]="disabled" [matMenuTriggerFor]="menu" class="pkt-btn"
    [matTooltip]="tooltip" [matTooltipDisabled]="!tooltip">
    <span *ngIf="icon" class="material-symbols-outlined">{{ icon }}</span>
    <span *ngIf="label">{{ label }}</span>
    <span class="material-symbols-outlined pkt-chevron">keyboard_arrow_down</span>
  </button>

  <mat-menu #menu="matMenu" class="pkt-dropdown-menu">
    <ng-container *ngFor="let item of items; trackBy: trackByIndex">
      <mat-divider *ngIf="item.divider"></mat-divider>
      <button *ngIf="!item.divider" mat-menu-item [disabled]="item.disabled" (click)="onItemClick(item)">
        <span *ngIf="item.icon" class="material-symbols-outlined pkt-menu-icon">{{ item.icon }}</span>
        {{ item.label }}
      </button>
    </ng-container>
  </mat-menu>
</div>